export default function pickerJs(colourData) {
	try {
		let paletteSelect = getPaletteSelect(colourData.selectFieldNames);
		let colourPalette = getColourPalette(paletteSelect, colourData);
		setCssColours(colourPalette);
		let acfPaletteFields = [];

		if (typeof acf != 'undefined') {
			import('./colour-picker-styles.scss');
			// This runs only once when the colour pickers initialize
			acf.add_filter('color_picker_args', function (args, field) {
				acfPaletteFields.push(field);
				args.palettes = colourPalette.colours;
				return args;
			});
		}

		// Listener for when you change palette in the admin
		if (paletteSelect) {
			jQuery(paletteSelect).on('select2:select', function (event) {
				let colourPalette = getColourPalette(paletteSelect, colourData);
				setCssColours(colourPalette);
				updatePickerInputs(colourPalette, acfPaletteFields);
			});
		}
	} catch (error) {
		console.log(error);
	}

	/**
	 * getPaletteSelect
	 *
	 * @param {array} selectFieldNames An array containing the names of the acf pickers
	 * @returns {HTMLElement} The current picker to listen for changes
	 */
	function getPaletteSelect(selectFieldNames) {
		let selectElement;
		selectFieldNames.forEach((name) => {
			document.querySelector(`[data-name=${name}] select`)
				? (selectElement = document.querySelector(
						`[data-name=${name}] select`
				  ))
				: false;
		});
		return selectElement;
	}

	/**
	 * setCssColours
	 *
	 * @param {array} colours An array of colours from the current palette.
	 * @param {array} textColours An array of colours from the text palette.
	 * @param {HTMLElement} element the html element to scope the variables to.
	 */
	function setCssColours(
		colourData,
		textColours = colourData['text'],
		element = document.querySelector(':root')
	) {
		colourData.colours.forEach((colour, index) => {
			element.style.setProperty(`--palette-default-${index + 1}`, colour);
		});
		textColours.forEach((colour, index) =>
			element.style.setProperty(
				`--text-colour-default-${index + 1}`,
				colour
			)
		);

		element.style.setProperty(
			`--theme-primary-text-colour`,
			colourData['theme_primary_text_colour']
		)
		element.style.setProperty(
			`--theme-secondary-text-colour`,
			colourData['theme_secondary_text_colour']
		)
		element.style.setProperty(
			`--theme-primary-background-colour`,
			colourData['theme_primary_background_colour']
		)
		element.style.setProperty(
			`--theme-secondary-background-colour`,
			colourData['theme_secondary_background_colour']
		)
	}
	/**
	 * getColourPalette
	 *
	 * @param {HTMLElement} select
	 * @param {object} paletteData
	 * @returns {array} An array of colours as hex strings.
	 */
	function getColourPalette(select, paletteData) {
		let coloursArray = [];
		const currentLivePalette =
			document.querySelector('html').dataset.currentcolourpalette;
			let currentData = 'default';
			if (select) {
				document.querySelector('html').dataset.currentcolourpalette = `theme-${select.value.replace('__', '')}`;
				currentData = paletteData[`theme-${select.value.replace('__', '')}`];
			} else if (currentLivePalette) {
				currentData = paletteData[currentLivePalette];
			}
		if (currentData === 'default') {
			coloursArray = paletteData.default;
		} else {
			coloursArray = currentData;
		}
		return coloursArray;
	}

	/**
	 * updatePickerInputs
	 *
	 * @param {array} colourData The current colour palette to apply to the acf pickers.
	 * @param {array} fields The acf picker elements to apply the palettes to.
	 */
	function updatePickerInputs(colourData = [], fields = []) {
		fields.forEach((field) => {
			jQuery(field).find('input.wp-color-picker').iris({
				palettes: colourData.colours
			});
			jQuery(field).find('input.wp-picker-clear').trigger('click');
		});
	}
}
